import React, { Component } from 'react';
import Anchor from "../../objects/Anchor";

class BackButton extends Component {

    render() {
        const { title, path } = this.props;
        return (
            <Anchor path={path} anchorClass="theme-back-button clickable reverse-hover" internal>
                <img src="/images/icons-new/left-arrow.svg" alt="back arrow" className="click-icon"/>
                {title}
            </Anchor>
        );
    }
}

export default BackButton;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/tools/BackButton.js